"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Shipment Assembly
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.31
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.WeightUnitType = exports.VolumeUnitType = exports.TempUnitType = exports.StopType = exports.SpeedUnitType = exports.PaymentTermsEnum = exports.PackageType = exports.OrderResourceType = exports.OptimizationStatus = exports.OptimizationCategoryConstraintOperator = exports.LoadSchemaModeEnum = exports.JobStates = exports.DistanceUnitType = exports.CreateShipmentRequestBodyModeEnum = exports.CompanyIncludes = exports.ActionType = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ActionType;
(function (ActionType) {
    ActionType["DeleteOrder"] = "DELETE_ORDER";
    ActionType["ModelRerun"] = "MODEL_RERUN";
    ActionType["SuggestToRerun"] = "SUGGEST_TO_RERUN";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var CompanyIncludes;
(function (CompanyIncludes) {
    CompanyIncludes["CategoryConstraints"] = "category_constraints";
})(CompanyIncludes = exports.CompanyIncludes || (exports.CompanyIncludes = {}));
/**
    * @export
    * @enum {string}
    */
var CreateShipmentRequestBodyModeEnum;
(function (CreateShipmentRequestBodyModeEnum) {
    CreateShipmentRequestBodyModeEnum["Ltl"] = "LTL";
    CreateShipmentRequestBodyModeEnum["Ftl"] = "FTL";
    CreateShipmentRequestBodyModeEnum["Vltl"] = "VLTL";
    CreateShipmentRequestBodyModeEnum["Drayage"] = "DRAYAGE";
    CreateShipmentRequestBodyModeEnum["Parcel"] = "PARCEL";
    CreateShipmentRequestBodyModeEnum["Intermodal"] = "INTERMODAL";
})(CreateShipmentRequestBodyModeEnum = exports.CreateShipmentRequestBodyModeEnum || (exports.CreateShipmentRequestBodyModeEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var DistanceUnitType;
(function (DistanceUnitType) {
    DistanceUnitType["Miles"] = "miles";
    DistanceUnitType["Kilometers"] = "kilometers";
})(DistanceUnitType = exports.DistanceUnitType || (exports.DistanceUnitType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var JobStates;
(function (JobStates) {
    JobStates["Running"] = "RUNNING";
    JobStates["Success"] = "SUCCESS";
    JobStates["Failed"] = "FAILED";
})(JobStates = exports.JobStates || (exports.JobStates = {}));
/**
    * @export
    * @enum {string}
    */
var LoadSchemaModeEnum;
(function (LoadSchemaModeEnum) {
    LoadSchemaModeEnum["Ltl"] = "LTL";
    LoadSchemaModeEnum["Ftl"] = "FTL";
})(LoadSchemaModeEnum = exports.LoadSchemaModeEnum || (exports.LoadSchemaModeEnum = {}));
/**
 * Operators that can be used to describe the meaning of OptimizationCategoryConstraints
 * @export
 * @enum {string}
 */
var OptimizationCategoryConstraintOperator;
(function (OptimizationCategoryConstraintOperator) {
    OptimizationCategoryConstraintOperator["NotWith"] = "NOT_WITH";
    OptimizationCategoryConstraintOperator["OnlyWith"] = "ONLY_WITH";
    OptimizationCategoryConstraintOperator["Individually"] = "INDIVIDUALLY";
    OptimizationCategoryConstraintOperator["Ignore"] = "IGNORE";
})(OptimizationCategoryConstraintOperator = exports.OptimizationCategoryConstraintOperator || (exports.OptimizationCategoryConstraintOperator = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OptimizationStatus;
(function (OptimizationStatus) {
    OptimizationStatus["GettingRates"] = "GETTING RATES";
    OptimizationStatus["Calculating"] = "CALCULATING";
    OptimizationStatus["Ready"] = "READY";
    OptimizationStatus["Archived"] = "ARCHIVED";
    OptimizationStatus["Approved"] = "APPROVED";
    OptimizationStatus["Failed"] = "FAILED";
    OptimizationStatus["Blocked"] = "BLOCKED";
})(OptimizationStatus = exports.OptimizationStatus || (exports.OptimizationStatus = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var OrderResourceType;
(function (OrderResourceType) {
    OrderResourceType["Order"] = "order";
    OrderResourceType["SalesOrder"] = "sales_order";
    OrderResourceType["PurchaseOrder"] = "purchase_order";
})(OrderResourceType = exports.OrderResourceType || (exports.OrderResourceType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var PackageType;
(function (PackageType) {
    PackageType["Plt"] = "PLT";
    PackageType["Case"] = "CASE";
    PackageType["Pieces"] = "PIECES";
    PackageType["Bag"] = "BAG";
    PackageType["Bale"] = "BALE";
    PackageType["Bottle"] = "BOTTLE";
    PackageType["Box"] = "BOX";
    PackageType["Bucket"] = "BUCKET";
    PackageType["Bundle"] = "BUNDLE";
    PackageType["Can"] = "CAN";
    PackageType["Carton"] = "CARTON";
    PackageType["Coil"] = "COIL";
    PackageType["Crate"] = "CRATE";
    PackageType["Cylinder"] = "CYLINDER";
    PackageType["Drum"] = "DRUM";
    PackageType["Jerrican"] = "JERRICAN";
    PackageType["Pail"] = "PAIL";
    PackageType["Reel"] = "REEL";
    PackageType["Roll"] = "ROLL";
    PackageType["Skid"] = "SKID";
    PackageType["Tote"] = "TOTE";
    PackageType["Tube"] = "TUBE";
    PackageType["Package"] = "PACKAGE";
    PackageType["Pkg"] = "PKG";
    PackageType["FloorLoaded"] = "FLOOR_LOADED";
    PackageType["Unit"] = "UNIT";
    PackageType["ToteBin"] = "TOTE_BIN";
    PackageType["ToteCan"] = "TOTE_CAN";
    PackageType["Bin"] = "BIN";
    PackageType["Other"] = "OTHER";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var PaymentTermsEnum;
(function (PaymentTermsEnum) {
    PaymentTermsEnum["Prepaid"] = "PREPAID";
    PaymentTermsEnum["Collect"] = "COLLECT";
    PaymentTermsEnum["_3RdParty"] = "3RD_PARTY";
})(PaymentTermsEnum = exports.PaymentTermsEnum || (exports.PaymentTermsEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var SpeedUnitType;
(function (SpeedUnitType) {
    SpeedUnitType["Mph"] = "mph";
    SpeedUnitType["Kph"] = "kph";
})(SpeedUnitType = exports.SpeedUnitType || (exports.SpeedUnitType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var StopType;
(function (StopType) {
    StopType["Pickup"] = "pickup";
    StopType["Drop"] = "drop";
})(StopType = exports.StopType || (exports.StopType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TempUnitType;
(function (TempUnitType) {
    TempUnitType["C"] = "C";
    TempUnitType["F"] = "F";
})(TempUnitType = exports.TempUnitType || (exports.TempUnitType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var VolumeUnitType;
(function (VolumeUnitType) {
    VolumeUnitType["Ft"] = "FT";
    VolumeUnitType["M"] = "M";
})(VolumeUnitType = exports.VolumeUnitType || (exports.VolumeUnitType = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var WeightUnitType;
(function (WeightUnitType) {
    WeightUnitType["Lb"] = "LB";
    WeightUnitType["Kg"] = "KG";
})(WeightUnitType = exports.WeightUnitType || (exports.WeightUnitType = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Acknowledge Errors
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeErrorsPost: function (loadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('acknowledgeErrorsPost', 'loadId', loadId);
                            localVarPath = "/shipment-assembly/load/{load_id}/acknowledge_errors"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add Orders
         * @param {string} loadId
         * @param {Array<OptimizeOrderSchema>} optimizeOrderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrdersLoadPost: function (loadId, optimizeOrderSchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('addOrdersLoadPost', 'loadId', loadId);
                            // verify required parameter 'optimizeOrderSchema' is not null or undefined
                            (0, common_1.assertParamExists)('addOrdersLoadPost', 'optimizeOrderSchema', optimizeOrderSchema);
                            localVarPath = "/shipment-assembly/load/{load_id}/orders/add"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(optimizeOrderSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Approve Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoadPut: function (loadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('approveLoadPut', 'loadId', loadId);
                            localVarPath = "/shipment-assembly/load/{load_id}/approve"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Archive Company By Id
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompanyDelete: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('archiveCompanyDelete', 'companyId', companyId);
                            localVarPath = "/shipment-assembly/company/{company_id}"
                                .replace("{".concat("company_id", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Company
         * @param {CreateCompanySchema} createCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyPost: function (createCompanySchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCompanySchema' is not null or undefined
                            (0, common_1.assertParamExists)('createCompanyPost', 'createCompanySchema', createCompanySchema);
                            localVarPath = "/shipment-assembly/company";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCompanySchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Plan
         * @param {PlanSchema} planSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanPost: function (planSchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'planSchema' is not null or undefined
                            (0, common_1.assertParamExists)('createPlanPost', 'planSchema', planSchema);
                            localVarPath = "/shipment-assembly/plan";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(planSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a shipment for one or more [orders](https://docs.shipwell.com/openapi_pages/backend-core/tag/purchase-orders/paths/~1purchase-orders~1%7BpurchaseOrderId%7D~1/get/)
         * @summary Create Shipment
         * @param {CreateShipmentRequestBody} createShipmentRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentPost: function (createShipmentRequestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createShipmentRequestBody' is not null or undefined
                            (0, common_1.assertParamExists)('createShipmentPost', 'createShipmentRequestBody', createShipmentRequestBody);
                            localVarPath = "/shipment-assembly/load/create_shipment";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentRequestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Orders
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersLoadPost: function (loadId, requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOrdersLoadPost', 'loadId', loadId);
                            // verify required parameter 'requestBody' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOrdersLoadPost', 'requestBody', requestBody);
                            localVarPath = "/shipment-assembly/load/{load_id}/orders/delete"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get OptimizationCategoryConstraints related to a Company
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryConstraintsGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('getCategoryConstraintsGet', 'companyId', companyId);
                            localVarPath = "/shipment-assembly/company/{company_id}/category-constraints"
                                .replace("{".concat("company_id", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Company By Id
         * @param {string} companyId
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIdGet: function (companyId, includes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('getCompanyByIdGet', 'companyId', companyId);
                            localVarPath = "/shipment-assembly/company/{company_id}"
                                .replace("{".concat("company_id", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (includes) {
                                localVarQueryParameter['includes'] = includes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Company
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyGet: function (includes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipment-assembly/company";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (includes) {
                                localVarQueryParameter['includes'] = includes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadGet: function (loadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('getLoadGet', 'loadId', loadId);
                            localVarPath = "/shipment-assembly/load/{load_id}"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanGet: function (planId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'planId' is not null or undefined
                            (0, common_1.assertParamExists)('getPlanGet', 'planId', planId);
                            localVarPath = "/shipment-assembly/plan/{plan_id}"
                                .replace("{".concat("plan_id", "}"), encodeURIComponent(String(planId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Plan Pdf
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanPdfGet: function (planId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'planId' is not null or undefined
                            (0, common_1.assertParamExists)('getPlanPdfGet', 'planId', planId);
                            localVarPath = "/shipment-assembly/plan/{plan_id}/pdf"
                                .replace("{".concat("plan_id", "}"), encodeURIComponent(String(planId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Companies
         * @param {Array<CompanyIncludes>} [includes]
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompaniesGet: function (includes, page, size, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipment-assembly/companies";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (includes) {
                                localVarQueryParameter['includes'] = includes;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Plans
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlansGet: function (page, size, sort, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipment-assembly/plans";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (sort !== undefined) {
                                localVarQueryParameter['sort'] = sort;
                            }
                            if (direction !== undefined) {
                                localVarQueryParameter['direction'] = direction;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Optimize Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeLoadPost: function (loadId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('optimizeLoadPost', 'loadId', loadId);
                            localVarPath = "/shipment-assembly/load/{load_id}/optimize"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Optimize Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizePlanPost: function (planId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'planId' is not null or undefined
                            (0, common_1.assertParamExists)('optimizePlanPost', 'planId', planId);
                            localVarPath = "/shipment-assembly/plan/{plan_id}/optimize"
                                .replace("{".concat("plan_id", "}"), encodeURIComponent(String(planId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Reorder Stops
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStopsPost: function (loadId, requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('reorderStopsPost', 'loadId', loadId);
                            // verify required parameter 'requestBody' is not null or undefined
                            (0, common_1.assertParamExists)('reorderStopsPost', 'requestBody', requestBody);
                            localVarPath = "/shipment-assembly/load/{load_id}/reorder_stops"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk-update all OptimizationCategoryConstraints for a Company
         * @param {string} companyId
         * @param {BulkUpdateOptimizationCategoryConstraints} bulkUpdateOptimizationCategoryConstraints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryConstraintsPut: function (companyId, bulkUpdateOptimizationCategoryConstraints, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('updateCategoryConstraintsPut', 'companyId', companyId);
                            // verify required parameter 'bulkUpdateOptimizationCategoryConstraints' is not null or undefined
                            (0, common_1.assertParamExists)('updateCategoryConstraintsPut', 'bulkUpdateOptimizationCategoryConstraints', bulkUpdateOptimizationCategoryConstraints);
                            localVarPath = "/shipment-assembly/company/{company_id}/category-constraints"
                                .replace("{".concat("company_id", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkUpdateOptimizationCategoryConstraints, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Company By Id
         * @param {string} companyId
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByIdPut: function (companyId, updateCompanySchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('updateCompanyByIdPut', 'companyId', companyId);
                            // verify required parameter 'updateCompanySchema' is not null or undefined
                            (0, common_1.assertParamExists)('updateCompanyByIdPut', 'updateCompanySchema', updateCompanySchema);
                            localVarPath = "/shipment-assembly/company/{company_id}"
                                .replace("{".concat("company_id", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCompanySchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Company
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyPut: function (updateCompanySchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateCompanySchema' is not null or undefined
                            (0, common_1.assertParamExists)('updateCompanyPut', 'updateCompanySchema', updateCompanySchema);
                            localVarPath = "/shipment-assembly/company";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCompanySchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Load
         * @param {string} loadId
         * @param {LoadSchema} loadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadPut: function (loadId, loadSchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadId' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadPut', 'loadId', loadId);
                            // verify required parameter 'loadSchema' is not null or undefined
                            (0, common_1.assertParamExists)('updateLoadPut', 'loadSchema', loadSchema);
                            localVarPath = "/shipment-assembly/load/{load_id}"
                                .replace("{".concat("load_id", "}"), encodeURIComponent(String(loadId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loadSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Plan Name
         * @param {string} planId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanNamePut: function (planId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'planId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePlanNamePut', 'planId', planId);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('updatePlanNamePut', 'body', body);
                            localVarPath = "/shipment-assembly/plan/{plan_id}/name"
                                .replace("{".concat("plan_id", "}"), encodeURIComponent(String(planId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Acknowledge Errors
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeErrorsPost: function (loadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.acknowledgeErrorsPost(loadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add Orders
         * @param {string} loadId
         * @param {Array<OptimizeOrderSchema>} optimizeOrderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrdersLoadPost: function (loadId, optimizeOrderSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addOrdersLoadPost(loadId, optimizeOrderSchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Approve Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoadPut: function (loadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.approveLoadPut(loadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Archive Company By Id
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompanyDelete: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.archiveCompanyDelete(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Company
         * @param {CreateCompanySchema} createCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyPost: function (createCompanySchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCompanyPost(createCompanySchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Plan
         * @param {PlanSchema} planSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanPost: function (planSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPlanPost(planSchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a shipment for one or more [orders](https://docs.shipwell.com/openapi_pages/backend-core/tag/purchase-orders/paths/~1purchase-orders~1%7BpurchaseOrderId%7D~1/get/)
         * @summary Create Shipment
         * @param {CreateShipmentRequestBody} createShipmentRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentPost: function (createShipmentRequestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShipmentPost(createShipmentRequestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Orders
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersLoadPost: function (loadId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOrdersLoadPost(loadId, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get OptimizationCategoryConstraints related to a Company
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryConstraintsGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCategoryConstraintsGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Company By Id
         * @param {string} companyId
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIdGet: function (companyId, includes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompanyByIdGet(companyId, includes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Company
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyGet: function (includes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCompanyGet(includes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadGet: function (loadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoadGet(loadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanGet: function (planId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPlanGet(planId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Plan Pdf
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanPdfGet: function (planId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPlanPdfGet(planId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Companies
         * @param {Array<CompanyIncludes>} [includes]
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompaniesGet: function (includes, page, size, sort, direction, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listCompaniesGet(includes, page, size, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List Plans
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlansGet: function (page, size, sort, direction, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPlansGet(page, size, sort, direction, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Optimize Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeLoadPost: function (loadId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.optimizeLoadPost(loadId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Optimize Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizePlanPost: function (planId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.optimizePlanPost(planId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Reorder Stops
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStopsPost: function (loadId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reorderStopsPost(loadId, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk-update all OptimizationCategoryConstraints for a Company
         * @param {string} companyId
         * @param {BulkUpdateOptimizationCategoryConstraints} bulkUpdateOptimizationCategoryConstraints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryConstraintsPut: function (companyId, bulkUpdateOptimizationCategoryConstraints, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCategoryConstraintsPut(companyId, bulkUpdateOptimizationCategoryConstraints, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Company By Id
         * @param {string} companyId
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByIdPut: function (companyId, updateCompanySchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCompanyByIdPut(companyId, updateCompanySchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Company
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyPut: function (updateCompanySchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCompanyPut(updateCompanySchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Load
         * @param {string} loadId
         * @param {LoadSchema} loadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadPut: function (loadId, loadSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLoadPut(loadId, loadSchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Plan Name
         * @param {string} planId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanNamePut: function (planId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePlanNamePut(planId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary Acknowledge Errors
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeErrorsPost: function (loadId, options) {
            return localVarFp.acknowledgeErrorsPost(loadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add Orders
         * @param {string} loadId
         * @param {Array<OptimizeOrderSchema>} optimizeOrderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrdersLoadPost: function (loadId, optimizeOrderSchema, options) {
            return localVarFp.addOrdersLoadPost(loadId, optimizeOrderSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Approve Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoadPut: function (loadId, options) {
            return localVarFp.approveLoadPut(loadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Archive Company By Id
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCompanyDelete: function (companyId, options) {
            return localVarFp.archiveCompanyDelete(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Company
         * @param {CreateCompanySchema} createCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyPost: function (createCompanySchema, options) {
            return localVarFp.createCompanyPost(createCompanySchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Plan
         * @param {PlanSchema} planSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanPost: function (planSchema, options) {
            return localVarFp.createPlanPost(planSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a shipment for one or more [orders](https://docs.shipwell.com/openapi_pages/backend-core/tag/purchase-orders/paths/~1purchase-orders~1%7BpurchaseOrderId%7D~1/get/)
         * @summary Create Shipment
         * @param {CreateShipmentRequestBody} createShipmentRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentPost: function (createShipmentRequestBody, options) {
            return localVarFp.createShipmentPost(createShipmentRequestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Orders
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrdersLoadPost: function (loadId, requestBody, options) {
            return localVarFp.deleteOrdersLoadPost(loadId, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get OptimizationCategoryConstraints related to a Company
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryConstraintsGet: function (companyId, options) {
            return localVarFp.getCategoryConstraintsGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Company By Id
         * @param {string} companyId
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIdGet: function (companyId, includes, options) {
            return localVarFp.getCompanyByIdGet(companyId, includes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Company
         * @param {Array<CompanyIncludes>} [includes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyGet: function (includes, options) {
            return localVarFp.getCompanyGet(includes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadGet: function (loadId, options) {
            return localVarFp.getLoadGet(loadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanGet: function (planId, options) {
            return localVarFp.getPlanGet(planId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Plan Pdf
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanPdfGet: function (planId, options) {
            return localVarFp.getPlanPdfGet(planId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Companies
         * @param {Array<CompanyIncludes>} [includes]
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompaniesGet: function (includes, page, size, sort, direction, options) {
            return localVarFp.listCompaniesGet(includes, page, size, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Plans
         * @param {number} [page]
         * @param {number} [size]
         * @param {string} [sort]
         * @param {'ASC' | 'DESC'} [direction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlansGet: function (page, size, sort, direction, options) {
            return localVarFp.listPlansGet(page, size, sort, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Optimize Load
         * @param {string} loadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizeLoadPost: function (loadId, options) {
            return localVarFp.optimizeLoadPost(loadId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Optimize Plan
         * @param {string} planId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizePlanPost: function (planId, options) {
            return localVarFp.optimizePlanPost(planId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Reorder Stops
         * @param {string} loadId
         * @param {Array<string>} requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStopsPost: function (loadId, requestBody, options) {
            return localVarFp.reorderStopsPost(loadId, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Bulk-update all OptimizationCategoryConstraints for a Company
         * @param {string} companyId
         * @param {BulkUpdateOptimizationCategoryConstraints} bulkUpdateOptimizationCategoryConstraints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryConstraintsPut: function (companyId, bulkUpdateOptimizationCategoryConstraints, options) {
            return localVarFp.updateCategoryConstraintsPut(companyId, bulkUpdateOptimizationCategoryConstraints, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Company By Id
         * @param {string} companyId
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByIdPut: function (companyId, updateCompanySchema, options) {
            return localVarFp.updateCompanyByIdPut(companyId, updateCompanySchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Company
         * @param {UpdateCompanySchema} updateCompanySchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyPut: function (updateCompanySchema, options) {
            return localVarFp.updateCompanyPut(updateCompanySchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Load
         * @param {string} loadId
         * @param {LoadSchema} loadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadPut: function (loadId, loadSchema, options) {
            return localVarFp.updateLoadPut(loadId, loadSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Plan Name
         * @param {string} planId
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanNamePut: function (planId, body, options) {
            return localVarFp.updatePlanNamePut(planId, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Acknowledge Errors
     * @param {string} loadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.acknowledgeErrorsPost = function (loadId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).acknowledgeErrorsPost(loadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add Orders
     * @param {string} loadId
     * @param {Array<OptimizeOrderSchema>} optimizeOrderSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addOrdersLoadPost = function (loadId, optimizeOrderSchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addOrdersLoadPost(loadId, optimizeOrderSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Approve Load
     * @param {string} loadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.approveLoadPut = function (loadId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).approveLoadPut(loadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Archive Company By Id
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.archiveCompanyDelete = function (companyId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).archiveCompanyDelete(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Company
     * @param {CreateCompanySchema} createCompanySchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createCompanyPost = function (createCompanySchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createCompanyPost(createCompanySchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Plan
     * @param {PlanSchema} planSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createPlanPost = function (planSchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createPlanPost(planSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a shipment for one or more [orders](https://docs.shipwell.com/openapi_pages/backend-core/tag/purchase-orders/paths/~1purchase-orders~1%7BpurchaseOrderId%7D~1/get/)
     * @summary Create Shipment
     * @param {CreateShipmentRequestBody} createShipmentRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createShipmentPost = function (createShipmentRequestBody, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createShipmentPost(createShipmentRequestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Orders
     * @param {string} loadId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.deleteOrdersLoadPost = function (loadId, requestBody, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteOrdersLoadPost(loadId, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get OptimizationCategoryConstraints related to a Company
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCategoryConstraintsGet = function (companyId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCategoryConstraintsGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Company By Id
     * @param {string} companyId
     * @param {Array<CompanyIncludes>} [includes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCompanyByIdGet = function (companyId, includes, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCompanyByIdGet(companyId, includes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Company
     * @param {Array<CompanyIncludes>} [includes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getCompanyGet = function (includes, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCompanyGet(includes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Load
     * @param {string} loadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getLoadGet = function (loadId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLoadGet(loadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPlanGet = function (planId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPlanGet(planId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Plan Pdf
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getPlanPdfGet = function (planId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPlanPdfGet(planId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Companies
     * @param {Array<CompanyIncludes>} [includes]
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [sort]
     * @param {'ASC' | 'DESC'} [direction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.listCompaniesGet = function (includes, page, size, sort, direction, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listCompaniesGet(includes, page, size, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Plans
     * @param {number} [page]
     * @param {number} [size]
     * @param {string} [sort]
     * @param {'ASC' | 'DESC'} [direction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.listPlansGet = function (page, size, sort, direction, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listPlansGet(page, size, sort, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Optimize Load
     * @param {string} loadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.optimizeLoadPost = function (loadId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).optimizeLoadPost(loadId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Optimize Plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.optimizePlanPost = function (planId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).optimizePlanPost(planId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Reorder Stops
     * @param {string} loadId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.reorderStopsPost = function (loadId, requestBody, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).reorderStopsPost(loadId, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Bulk-update all OptimizationCategoryConstraints for a Company
     * @param {string} companyId
     * @param {BulkUpdateOptimizationCategoryConstraints} bulkUpdateOptimizationCategoryConstraints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCategoryConstraintsPut = function (companyId, bulkUpdateOptimizationCategoryConstraints, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCategoryConstraintsPut(companyId, bulkUpdateOptimizationCategoryConstraints, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Company By Id
     * @param {string} companyId
     * @param {UpdateCompanySchema} updateCompanySchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCompanyByIdPut = function (companyId, updateCompanySchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCompanyByIdPut(companyId, updateCompanySchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Company
     * @param {UpdateCompanySchema} updateCompanySchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCompanyPut = function (updateCompanySchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCompanyPut(updateCompanySchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Load
     * @param {string} loadId
     * @param {LoadSchema} loadSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateLoadPut = function (loadId, loadSchema, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateLoadPut(loadId, loadSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Plan Name
     * @param {string} planId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updatePlanNamePut = function (planId, body, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updatePlanNamePut(planId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
